export const AUTOSUGGEST_EXP = 'AUTOSUGGEST_EXP' as const;
export const ENABLE_CALENDAR_PRICES = 'ENABLE_CALENDAR_PRICES' as const;
export const ENABLE_ENFORCE_TRIP_TYPE = 'ENABLE_ENFORCE_TRIP_TYPE' as const;
export const ENABLE_GTM = 'ENABLE_GTM' as const;
export const ENABLE_MONTH_VIEW_GTM_INTEGRATION =
  'ENABLE_MONTH_VIEW_GTM_INTEGRATION' as const;
export const ENABLE_PACKAGES_HEADER_TAB = 'ENABLE_PACKAGES_HEADER_TAB' as const;
export const ENABLE_PAGE_LOAD_DIAGNOSTIC =
  'ENABLE_PAGE_LOAD_DIAGNOSTIC' as const;
export const ENABLE_PRICE_CALENDAR_DATA = 'ENABLE_PRICE_CALENDAR_DATA' as const;
export const PACKAGES_HEADER_TAB_VERSION =
  'PACKAGES_HEADER_TAB_VERSION' as const;
export const DATE_SELECTION_VERSION = 'DATE_SELECTION_VERSION' as const;
export const ENABLE_CHEAPEST_DATES = 'ENABLE_CHEAPEST_DATES' as const;
export const ENABLE_FLEXIBLE_DATE_SELECTION_WITH_BACK_TO_DEPART =
  'ENABLE_FLEXIBLE_DATE_SELECTION_WITH_BACK_TO_DEPART' as const;
export const ENABLE_FLEXIBLE_DATE_SELECTION_WITH_STICK_TO_RETURN =
  'ENABLE_FLEXIBLE_DATE_SELECTION_WITH_STICK_TO_RETURN' as const;
export const ENABLE_DEAL_HUNTER_LITE = 'ENABLE_DEAL_HUNTER_LITE' as const;
export const ENABLE_MICHELIN_RECOMMENDATIONS =
  'ENABLE_MICHELIN_RECOMMENDATIONS' as const;
export const COMBO_RECOMMENDATION_TYPE = 'COMBO_RECOMMENDATION_TYPE' as const;
export const ENABLE_COMBO_RECOMMENDATION =
  'ENABLE_COMBO_RECOMMENDATION' as const;
export const CABIN_CLASS_EXP = 'CABIN_CLASS_EXP' as const;
export const BAGS_EXP = 'BAGS_EXP' as const;
export const ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_MWEB =
  'ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_MWEB' as const;
export const ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_DESKTOP =
  'ENABLE_BAGGAGE_FILTER_IN_SEARCH_RESULTS_DESKTOP' as const;
export const ENABLE_DEPARTURE_TIMES = 'ENABLE_DEPARTURE_TIMES' as const;
